import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, MapPin, Send } from 'lucide-react';

const Contact: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="page-section">
      <div className="page-container">
        <div className="page-intro">
          <p className="eyebrow">We would love to hear from you</p>
          <h1 className="page-title">{t('contact.title', 'Contact Us')}</h1>
          <p className="page-description">Questions about membership, events, partnerships, or the Jacksonville community are always welcome.</p>
        </div>
        <div className="grid gap-8 lg:grid-cols-[1.1fr_0.9fr]">
          {/* Contact Form */}
          <div className="surface p-6 sm:p-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">
              {t('contact.form.title', 'Send us a Message')}
            </h2>
            <form className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                  {t('contact.form.name', 'Your Name')}
                </label>
                <input
                  type="text"
                  id="name"
                  className="w-full border border-[#cfd6df] bg-[#fbfcfd] px-4 py-3 focus:border-[#2457a7] focus:bg-white"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  {t('contact.form.email', 'Email Address')}
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full border border-[#cfd6df] bg-[#fbfcfd] px-4 py-3 focus:border-[#2457a7] focus:bg-white"
                />
              </div>
              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">
                  {t('contact.form.subject', 'Subject')}
                </label>
                <input
                  type="text"
                  id="subject"
                  className="w-full border border-[#cfd6df] bg-[#fbfcfd] px-4 py-3 focus:border-[#2457a7] focus:bg-white"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  {t('contact.form.message', 'Message')}
                </label>
                <textarea
                  id="message"
                  rows={4}
                  className="w-full border border-[#cfd6df] bg-[#fbfcfd] px-4 py-3 focus:border-[#2457a7] focus:bg-white"
                ></textarea>
              </div>
              <button
                type="submit"
                className="btn-primary w-full"
              >
                <Send className="w-5 h-5" />
                <span>{t('contact.form.submit', 'Send Message')}</span>
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="space-y-5">
            <div className="bg-[#2457a7] p-7 text-white sm:p-8">
              <h2 className="mb-6 text-2xl font-bold">
                {t('contact.info.title', 'Get in Touch')}
              </h2>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <Mail className="mt-1 h-5 w-5 text-[#f4b7c2]" />
                  <div>
                    <p className="font-medium">Email</p>
                    <a href="mailto:jaxjapanese@gmail.com" className="text-white/70 hover:text-white">jaxjapanese@gmail.com</a>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <MapPin className="mt-1 h-5 w-5 text-[#f4b7c2]" />
                  <div>
                    <p className="font-medium">Location</p>
                    <p className="text-white/70">Jacksonville, Florida</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="surface p-7 sm:p-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('contact.faq.title', 'Frequently Asked Questions')}
              </h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-medium text-gray-900">How can I become a member?</h3>
                  <p className="text-gray-600 mt-1">Visit our membership page to learn about the process and benefits.</p>
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">When are your events held?</h3>
                  <p className="text-gray-600 mt-1">Check our events page for upcoming activities and gatherings.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
